/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Ładowanie...',
	'dlg_close': 'Zamknij',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Anuluj',
	'dlg_back': 'Wstecz',

	// Slider
	'sliderRegionLabel': 'Kontrolka suwaka. W celu przesuwania uchwytów suwaka użyj strzałek w prawo i lewo',
	'sliderHandleLabel': 'Uchwyt suwaka',
	'a11ySliderHandleLabel': 'Uchwyt suwaka %{sliderValue}',
	'sliderInputLabel': 'wartość',

	// Side bar
	'sidebarAdd': 'Dodaj',
	'clearTextFilterValue': 'Wyczyść',
	'missingDataSetData': 'Dane tego zestawu danych nie są dostępne. Odśwież zestaw danych lub skontaktuj się z administratorem w sprawie dostępu do źródła.',

	// Toolbar
	'toolbarRegionLabel': 'Pasek narzędzi',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Rodzina czcionek',
	'fontSizeSelect': 'Rozmiar czcionki',
	'bold': 'Pogrubienie',
	'italic': 'Kursywa',
	'underline': 'Podkreślenie',
	'justifyLeft': 'Wyrównanie do lewej',
	'justifyCenter': 'Wyśrodkowanie',
	'justifyRight': 'Wyrównanie do prawej',
	'insertOrderedList': 'Lista uporządkowana',
	'insertUnorderedList': 'Lista nieuporządkowana',
	'fontColorPicker': 'Selektor kolorów',
	'textWrap': 'Zawijaj tekst',
	'restore': 'Odtwórz wartości domyślne',
	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Liczba wyników',
	'topbottomPercentLabel': 'Procent',
	'topbottomNumberOfResultsLimit': 'Wartość może należeć do przedziału %{lower}-%{higher}',
	'topbottomSelectOption': 'Opcja Od góry lub od dołu',
	'topbottomOptionLabel': 'Pokaż',
	'searchByLabel': 'Wg',
	'searchNoMatches': 'Nie znaleziono danych spełniających kryteria',
	'topbottomRankColumnLabel': 'Dodaj kolumnę klasyfikacji do tabeli',
	'topbottomNone': 'Brak',
	'topCount': 'Liczba najwyższych',
	'topPercent': '% najwyższych',
	'bottomCount': 'Liczba najniższych',
	'bottomPercent': '% najniższych',
	'searchColumn': 'Znajdź kolumnę',
	'searchColumnAriaLabel': 'Znajdź kolumnę. Wpisz nazwę poszukiwanej kolumny, a następnie użyj strzałki w dół, aby odnaleźć ją na liście.',
	'rankColumnLabel': 'Klasyfikacja (%{columnLabel})',
	'topbottomClearLabel': 'Wyczyść',

	// Format
	'formatAuto': 'Auto',
	'formatConvertPercent': 'Przekształć wartość dziesiętną w wartość procentową',
	'formatAbbreviate': 'Skracaj',
	'formatUseGrouping': 'Użyj separatora tysięcy',
	'dateStyle': 'Styl daty',
	'dateTimeStyle': 'Styl daty/godziny',
	'formatMissingValueCharactersInfo': 'Znaki brakujących wartości to znaki, które mają być wyświetlane zamiast brakujących wartości.',
	'currencySymbolLabel': 'Symbol waluty',
	'customSymbolPlaceholder': 'Dodaj symbol',
	'customSymbolLabelInfo': 'Określa znak lub znaki, które będą wykorzystywane jako symbol niestandardowy. Symbol ten będzie poprzedzał liczbę i ewentualny znak. ',
	'numberLabel': 'Etykieta liczby',
	'numberPositionLabel': 'Położenie etykiety',
	'numberLabelInfo': 'Określa etykietę sformatowanej liczby umieszczaną jako przedrostek lub przyrostek, w zależności od położenia.',
	'nullValueDefault': '<domyślnie>',
	'nullValueContent': '(brak wartości)',
	'default': 'Domyślnie',
	'beginning': 'Początek',
	'end': 'Koniec',

	// More data indicator
	'moreDataIndicator': 'Twoje dane zostały obcięte przy takiej liczbie pozycji: %{threshold}. Zastosuj filtr, aby wyświetlać mniej.',

	// Expanded View / Focus mode
	'evCollapse': 'Zwiń',
	'duplicate': 'Duplikuj',
	'copyOf': 'Kopia %{name}',
	'unableToDuplicateBoard': 'Nie można powielić: "%{name}".',

	// Widget list
	'errorLoadingWidgetList': 'Nie można załadować tych obiektów.',

	// Custom widgets
	'customWidget': 'Widget niestandardowy'
});
